import * as React from 'react';
import { getTelemetry } from '@cian/telemetry/browser';

import { YANDEX_API_TELEMETRY_KEY } from '../../../constants/map';
import { EPanoramaState, IRegularInfrastructureData } from '../../../types/map';
import { trackPanoramaShow } from '../analytics';
import { toRegularInfrastructureItems } from '../helpers/mappers';

export const usePanorama = (
  TAInfrastructureTypeRef: React.MutableRefObject<string | undefined>,
  regularInfrastructureTypeRef: React.MutableRefObject<string | undefined>,
  regularInfrastructureMap: Map<number, IRegularInfrastructureData>,
) => {
  const [panoramaState, setPanoramaState] = React.useState<EPanoramaState | null>(null);

  const enterInfrastructureTypeRef = React.useRef<string | undefined>();

  const regularInfrastructureItems = React.useMemo(
    () => toRegularInfrastructureItems(regularInfrastructureMap),
    [regularInfrastructureMap],
  );

  const handlePanoramaSuccessEnter = React.useCallback(() => {
    const infrastructureType = getInfrastructureType(TAInfrastructureTypeRef, regularInfrastructureTypeRef);
    enterInfrastructureTypeRef.current = infrastructureType;

    getTelemetry().increment(YANDEX_API_TELEMETRY_KEY, 5);
    setPanoramaState(EPanoramaState.Loaded);
    trackPanoramaShow(true, regularInfrastructureItems, infrastructureType);
  }, [regularInfrastructureItems]);

  const handleNoPanoramaEnter = React.useCallback(() => {
    const infrastructureType = getInfrastructureType(TAInfrastructureTypeRef, regularInfrastructureTypeRef);
    enterInfrastructureTypeRef.current = infrastructureType;

    getTelemetry().increment(YANDEX_API_TELEMETRY_KEY, 5);
    setPanoramaState(EPanoramaState.None);
    trackPanoramaShow(true, regularInfrastructureItems, infrastructureType);
  }, [regularInfrastructureItems]);

  const handlePanoramaExit = React.useCallback(() => {
    setPanoramaState(null);
    trackPanoramaShow(false, regularInfrastructureItems, enterInfrastructureTypeRef.current);
  }, [regularInfrastructureItems]);

  const isPanoramaMode = panoramaState !== null;

  return {
    isPanoramaMode,
    handlePanoramaSuccessEnter,
    handleNoPanoramaEnter,
    handlePanoramaExit,
  };
};

function getInfrastructureType(
  TAInfrastructureTypeRef: React.MutableRefObject<string | undefined>,
  regularInfrastructureTypeRef: React.MutableRefObject<string | undefined>,
) {
  return TAInfrastructureTypeRef.current || regularInfrastructureTypeRef.current;
}
